"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _utils = require("../utils");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var REGEX = /^[\w.\-_]+@[\w_-]+?\.[a-zA-Z]{2,63}(\.[a-zA-Z]{2})?$/;
var EMAIL_INPUT_TYPE = 'email';
var EmailField = props => {
  var {
    value = '',
    onChange = () => {},
    isRequired = false,
    requireConfirm = false,
    clickedSubmit = false,
    label = _staticContent.EMAIL_FIELD.DEFAULT_LABEL,
    hint,
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    placeholder,
    maxlength,
    language = _constants.CONTENTFUL_LOCALE.en,
    inputRef = /*#__PURE__*/_react.default.createRef(),
    customErrorMessage = '',
    isReadOnly = false,
    confirmEmailLabel = _staticContent.EMAIL_FIELD.CONFIRM_DEFAULT_LABEL
  } = props;
  var [emailFeedback, setEmailFeedback] = (0, _react.useState)(undefined);
  var [emailError, setEmailError] = (0, _react.useState)(undefined);
  var [confirmEmailValue, setConfirmEmailValue] = (0, _react.useState)('');
  var [confirmEmailFeedback, setConfirmEmailFeedback] = (0, _react.useState)(undefined);
  var [confirmEmailError, setConfirmEmailError] = (0, _react.useState)(undefined);
  var [emailValue, setEmailValue] = (0, _react.useState)(value);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  var validateConfirmValue = (0, _react.useCallback)(value => {
    var isValid = true;
    isValid = isValid && value.toLowerCase() === emailValue.toLowerCase();
    return isValid;
  }, [emailValue]);
  var validate = (0, _react.useCallback)(value => {
    var isValid = true;

    // We need to check if required, if so then check length and ensure its > 0
    isValid = isValid && (isRequired ? value.length > 0 : true);

    // We need to ensure the value is a valid email format, if the length > 0
    isValid = isValid && (value.length > 0 ? REGEX.test(value) : true);

    // When given a maxlength, ensure the length is less or equal to
    isValid = isValid && (maxlength !== undefined ? value.length <= maxlength : true);
    return isValid;
  }, [isRequired, maxlength]);
  (0, _react.useEffect)(() => {
    if (isReadOnly && requireConfirm && value) {
      setConfirmEmailValue(value);
    }
  }, [isReadOnly, value, requireConfirm]);

  // Validate both email and confirm email, then set parent isValid flag as true
  (0, _react.useEffect)(() => {
    var isValid = validate(value);
    if (requireConfirm) {
      isValid = isValid && validateConfirmValue(confirmEmailValue);
    }
    onChange(value, isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange, validate, value, confirmEmailValue]);
  var updateConfirmEmailValidationMessage = (0, _react.useCallback)(value => {
    var isValid = validateConfirmValue(value);
    setConfirmEmailFeedback(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
    setConfirmEmailError(isValid ? undefined : _staticContent.EMAIL_FIELD.CONFIRM_ERROR[language]);
  }, [validateConfirmValue, language]);
  var updateEmailValidationMessage = (0, _react.useCallback)(value => {
    var isValid = validate(value);
    setEmailFeedback(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
    setEmailError(isValid ? undefined : customErrorMessage || _staticContent.EMAIL_FIELD.FORMAT_ERROR[language]);
  }, [validate, customErrorMessage, language]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      updateEmailValidationMessage(value);
      if (requireConfirm) {
        updateConfirmEmailValidationMessage(confirmEmailValue);
      }
    }
  }, [clickedSubmit, isRequired, requireConfirm, confirmEmailValue, updateConfirmEmailValidationMessage, updateEmailValidationMessage, value]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        updateEmailValidationMessage(value);
        if (requireConfirm) {
          updateConfirmEmailValidationMessage(confirmEmailValue);
        }
      }
    }
  }, [buttonControlPressed, inputRef, currentStepReferences, updateEmailValidationMessage, value, requireConfirm, confirmEmailValue, updateConfirmEmailValidationMessage]);
  var onFieldChange = val => {
    onChange(val, validate(val));
    setEmailValue(val);
  };
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.StackView, {
    space: 0
  }, /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.TextInput, {
    ref: inputRef,
    label: (0, _utils.formatLabel)(label, isRequired, language),
    hint: hint,
    hintPosition: hintPosition,
    type: EMAIL_INPUT_TYPE,
    value: emailValue,
    placeholder: placeholder,
    onBlur: e => {
      updateEmailValidationMessage(e.target.value);
      updateConfirmEmailValidationMessage(confirmEmailValue);
    },
    onChange: onFieldChange,
    maxLength: maxlength,
    validation: emailFeedback,
    feedback: emailError,
    "data-di-mask": true,
    inactive: isReadOnly
  })), requireConfirm && /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.TextInput, {
    label: (0, _utils.formatLabel)(confirmEmailLabel, isRequired, language),
    type: EMAIL_INPUT_TYPE,
    value: confirmEmailValue,
    placeholder: placeholder,
    onBlur: e => updateConfirmEmailValidationMessage(e.target.value),
    onChange: val => setConfirmEmailValue(val),
    maxLength: maxlength,
    validation: confirmEmailFeedback,
    feedback: confirmEmailError,
    "data-di-mask": true,
    inactive: isReadOnly
  })));
};
EmailField.propTypes = {
  label: _propTypes.default.string,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  maxlength: _propTypes.default.number,
  requireConfirm: _propTypes.default.bool,
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  inputRef: _propTypes.default.object,
  customErrorMessage: _propTypes.default.string,
  confirmEmailLabel: _propTypes.default.string
};
var _default = exports.default = EmailField;